var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "19",
        height: "19",
        viewBox: "0 0 19 19"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M14.374,78H5.226A4.934,4.934,0,0,0,.3,82.926v9.148A4.934,4.934,0,0,0,5.226,97h9.148A4.934,4.934,0,0,0,19.3,92.074V82.926A4.934,4.934,0,0,0,14.374,78Zm3.418,14.074a3.39,3.39,0,0,1-3.418,3.418H9.147V93.18A3.132,3.132,0,0,0,6.03,90.063,3.136,3.136,0,0,0,3.014,93.28v1.508a3.533,3.533,0,0,1-1.307-2.714V82.926a3.39,3.39,0,0,1,3.418-3.418h9.148a3.39,3.39,0,0,1,3.418,3.418v9.148Z",
          transform: "translate(-0.3 -78)",
          fill: "#293ad3"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }